// extracted by css-extract-rspack-plugin
export default {"grid":"_66045e1b"};